import React, { useEffect, useMemo, useState } from 'react';
import { Container, Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { receiptsApi } from '../../utils/receiptsApi';
import { auth } from '../../firebase';
import { checkReceiptsAdminAccess } from '../../utils/receiptsAccess';
import logger from '../../utils/logger';
import './ReceiptsLayout.css';

const NAV_ITEMS = [
  { path: '/receipts', label: 'Dashboard', end: true },
  { path: '/receipts/unsorted', label: 'Unsorted' },
  { path: '/receipts/transactions', label: 'Transactions' },
  { path: '/receipts/settings', label: 'Settings', adminOnly: true },
  { path: '/receipts/import', label: 'Import' },
  { path: '/receipts/export', label: 'Export' }
];

const SEED_STORAGE_KEY = 'receipts_settings_seeded';

const ReceiptsLayout = ({ children }) => {
  const location = useLocation();
  const [isReceiptsAdmin, setIsReceiptsAdmin] = useState(false);

  useEffect(() => {
    const firebaseUser = auth.currentUser;
    if (!firebaseUser) {
      setIsReceiptsAdmin(false);
      return;
    }
    checkReceiptsAdminAccess(firebaseUser)
      .then(setIsReceiptsAdmin)
      .catch(() => setIsReceiptsAdmin(false));
  }, []);

  useEffect(() => {
    if (!isReceiptsAdmin || typeof window === 'undefined' || window.localStorage.getItem(SEED_STORAGE_KEY)) {
      return;
    }
    receiptsApi
      .seedSettings()
      .then(() => {
        window.localStorage.setItem(SEED_STORAGE_KEY, '1');
      })
      .catch((err) => {
        logger.error('Failed to seed receipt settings', err);
      });
  }, [isReceiptsAdmin]);

  const visibleNavItems = useMemo(
    () => NAV_ITEMS.filter((item) => !item.adminOnly || isReceiptsAdmin),
    [isReceiptsAdmin]
  );

  const isActive = (path, end) => {
    if (end) {
      return location.pathname === path || location.pathname === `${path}/`;
    }
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  return (
    <Container fluid className="py-3 receipts-layout">
      <Nav variant="pills" className="receipts-subnav flex-wrap gap-1 mb-3">
        {visibleNavItems.map((item) => (
          <Nav.Item key={item.path}>
            <Nav.Link
              as={Link}
              to={item.path}
              active={isActive(item.path, item.end)}
            >
              {item.label}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
      {children}
    </Container>
  );
};

export default ReceiptsLayout;
